import { useModal } from "../ModalProvider";
import { ReactNode, useRef, MouseEvent } from "react";
import styled from "styled-components";
import closeModalIcon from "../closeModal.png";
import { useOnClickOutside } from "usehooks-ts";

type ModalDarkProps = {
	children: ReactNode;
	hideCloseIcon?: boolean;
	disableOutsideClose?: boolean;
};

const ModalDarkWrapper = styled.div`
	position: relative;
	display: flex;
	border-radius: 8px;
`;

const ModalDarkChildren = styled.div`
	display: flex;
	flex-direction: column;
	padding: 2rem;
	flex: 1;

	background: var(--surface);
	border-radius: 1rem;
`;

const ModalCloseIcon = styled.img`
	position: absolute;
	cursor: pointer;

	right: 1rem;
	top: 1rem;

	&:hover {
		filter: brightness(0.8);
	}
`;

export const ModalDark = ({
	children,
	hideCloseIcon = false,
	disableOutsideClose = false,
	...props
}: ModalDarkProps) => {
	const ref = useRef<HTMLDivElement>(null);
	const { closeModal } = useModal();

	useOnClickOutside(ref, disableOutsideClose ? () => {} : closeModal);

	return (
		<ModalDarkWrapper {...props}>
			<ModalDarkChildren onClick={(e) => e.stopPropagation()} ref={ref}>
				{children}
			</ModalDarkChildren>
			{!hideCloseIcon && (
				<ModalCloseIcon src={closeModalIcon} onClick={closeModal} />
			)}
		</ModalDarkWrapper>
	);
};
